import { Box, Toolbar, Typography } from '@mui/material';
import { MenuIcon } from 'lucide-react';
import { useLocation } from 'react-router-dom';

import {
  ThemeToggle,
  useSidebar,
  UtilityIconButton,
} from '@/components/common';
import { useDevice } from '@/hooks';

import { NotificationsMenu } from './NotificationsMenu';
import { ProfileSection } from './ProfileSection';

export const Header = () => {
  const location = useLocation();
  const { isMobile } = useDevice();
  const { toggle } = useSidebar();

  const PAGE_TITLES: Record<string, string> = {
    '/dashboard/home': 'Home',
    '/dashboard/analytics': 'Analytics',
    '/dashboard/users': 'Users',
    '/dashboard/orders': 'Orders',
    '/dashboard/customers': 'Customers',
    '/dashboard/outlet/menu': 'Menu',
    '/dashboard/outlet/tables': 'Tables',
    '/dashboard/profile': 'Profile',
    '/dashboard/settings': 'Settings',
    '/dashboard/settings/business': 'Settings',
    '/dashboard/settings/outlets': 'Settings',
    '/dashboard/settings/ordering': 'Settings',
    '/dashboard/settings/tax': 'Settings',
    '/dashboard/settings/notifications': 'Settings',
    '/dashboard/settings/subscriptions': 'Settings',
    '/dashboard/settings/subscriptions/plans': 'Settings',
    '/staff/home': 'Home',
    '/staff/kitchen': 'Kitchen',
    '/staff/billing': 'Billing',
    '/staff/waiter': 'Waiter',
    '/staff/delivery': 'Delivery',
  };

  const pageTitle = PAGE_TITLES[location.pathname] || 'Dashboard';

  return (
    <Box
      position="sticky"
      top={0}
      zIndex={1000}
      bgcolor="background.paper"
      mb={1}
    >
      <Toolbar sx={{ height: 64 }}>
        <Box display="flex" gap={1} alignItems="center">
          {isMobile && (
            <UtilityIconButton onClick={toggle} tooltip={{ title: 'Menu' }}>
              <MenuIcon size={16} />
            </UtilityIconButton>
          )}

          <Typography variant="h5" fontWeight={600}>
            {pageTitle}
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            marginLeft: 'auto',
            alignItems: 'center',
            gap: 1,
          }}
        >
          {/* Theme Toggle */}
          <ThemeToggle />

          {/* Notifications */}
          <NotificationsMenu />

          {/* Profile Section */}
          <ProfileSection />
        </Box>
      </Toolbar>
    </Box>
  );
};
